export const FT_ADDRESS_CHECK_V2_NEW_SHIPTO = 'ldt_address_check_v2_new_shipto';
export const FT_CCMS_V2_SHIPTO_GRAPHQL = 'ldt_ccmsv2_shipto_graphql';
